var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00014 14.5001C3.14025 14.5001 0 11.3599 0 7.50014C0 3.64025 3.14025 0.5 7.00014 0.5C10.8599 0.5 14 3.64025 14 7.50014C14 11.3599 10.8599 14.5001 7.00014 14.5001ZM7.00014 1.46075C3.66996 1.46075 0.960615 4.1701 0.960615 7.50014C0.960615 10.8303 3.66996 13.5395 7.00014 13.5395C10.3302 13.5395 13.0394 10.8303 13.0394 7.50014C13.0394 4.1701 10.3302 1.46075 7.00014 1.46075Z",
    fill: "#47B77B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05146 9.81783C5.92397 9.81783 5.80184 9.7672 5.71181 9.67717L3.9392 7.90456C3.75161 7.71711 3.75161 7.41287 3.9392 7.22541C4.1268 7.03768 4.43076 7.03768 4.61836 7.22541L6.05146 8.65823L9.38411 5.32559C9.57143 5.13799 9.87567 5.13799 10.0633 5.32559C10.2509 5.51304 10.2509 5.81728 10.0633 6.00474L6.39097 9.67717C6.30094 9.7672 6.17881 9.81783 6.05146 9.81783Z",
    fill: "#47B77B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/GreenCheck.0dd8f6ecaf81147e4f915823f0a85765.svg";
export { ForwardRef as ReactComponent };